import { companyRoutes } from '@/Company/routes'
import SponsorshipTemplateOne from '@/components/SponsorshipTemplates/SponsorshipTemplateOne.vue'
import PlainLayout from '@/layouts/PlainLayout.vue'
import { partnerRoutes } from '@/Partners/routes'
import platformRoutes from '@/Platform/routes'
import { termsRoutes } from '@/Terms/routes'
import { toolsRoutes } from '@/Tools/routes'
import { tradingRoutes } from '@/Trading/routes'
import HomeView from '@/views/HomeView.vue'
import PreferenceCentreView from '@/views/PreferenceCentreView.vue'
import PrivacyNoticeHml from '@/views/PrivacyNoticeHml.vue'
import SponsorshipOverview from '@/views/SponsorshipOverview.vue'
import TermsAndConditionsView from '@/views/TermsAndConditionsView.vue'
import UnsubscribePreferencesView from '@/views/UnsubscribePreferencesView.vue'
import UnsubscribeView from '@/views/UnsubscribeView.vue'

import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/live-account-pre-registration/',
    name: 'live-registration',
    component: () => import('@/views/LiveRegistrationView.vue'),
    props: (route) => ({ lang: route.params.lang || 'en' }),
    meta: { breadcrumbLabel: 'Live Registration' }
  },
  {
    path: '/:lang?/mt-demo-account/',
    name: 'demo-registration',
    component: () => import('@/views/DemoRegistrationView.vue'),
    props: (route) => ({ lang: route.params.lang || 'en' }),
    meta: { breadcrumbLabel: 'Demo Registration' }
  },
  {
    path: '/:lang?/contact-us/',
    name: 'contact-us',
    component: () => import('@/views/ContactUsView.vue'),
    props: (route) => ({ lang: route.params.lang || 'en' }),
    meta: { breadcrumbLabel: 'Live Registration' }
  },
  {
    path: '/:lang?/privacy-notice-hml/',
    name: 'privacy-notice-hml',
    component: PrivacyNoticeHml,
    props: (route) => ({ lang: route.params.lang || 'en' })
  },
  {
    path: '/:lang?/preference-centre/',
    name: 'preference-centre',
    component: PreferenceCentreView,
    props: (route) => ({ lang: route.params.lang || 'en' }),
    meta: { layout: PlainLayout }
  },
  {
    path: '/:lang?/institutional/',
    name: 'institutional',
    component: () => import('@/views/institutionalView.vue'),
    props: (route) => ({ lang: route.params.lang || 'en' }),
    meta: { breadcrumbLabel: 'Institutional' }
  },
  {
    path: '/:lang?/learn-to-trade/:menu_second?/:menu_fourth?',
    name: 'learn-to-trade',
    component: () => import('@/views/EducationView.vue'),
    props: (route) => ({
      lang: route.params.lang || 'en',
      menu_second: route.params.menu_second || 'learning-hub',
      menu_fourth: route.params.menu_fourth || 'what-is-cfd-trading'
    }),
    meta: { breadcrumbLabel: 'Education' }
  },
  {
    path: '/:lang?/trading-markets/:menu_second?',
    name: 'markets',
    component: () => import('@/views/MarketsView.vue'),
    props: (route) => ({
      lang: route.params.lang || 'en',
      menu_second: route.params.menu_second || 'forex-cfds'
    }),
    meta: { breadcrumbLabel: 'Markets' }
  },
  {
    path: '/:lang?/trade-with-us/:menu_second?',
    name: 'trading',
    component: () => import('@/views/TradingView.vue'),
    props: (route) => ({
      lang: route.params.lang || 'en',
      menu_second: route.params.menu_second || 'hantec-global'
    })
  },
  {
    path: '/:lang?/trade-with-us/:menu_second(our-charges)?',
    name: 'trading-costs-and-charges',
    component: () => import('@/views/TradingCostsAndChargesView.vue'),
    props: (route) => ({
      lang: route.params.lang || 'en',
      menu_second: route.params.menu_second || 'our-charges' // Default to 'our-charges'
    })
  },
  {
    path: '/:lang?/prime/',
    name: 'prime',
    component: () => import('@/views/PrimeView.vue'),
    props: (route) => ({ lang: route.params.lang || 'en' }),
    meta: { layout: PlainLayout }
  },
  {
    path: '/:lang?/live-account-pre-registration/hm-app-android/',
    name: 'register-android',
    component: () => import('@/views/PreregAppView.vue'),
    props: (route) => ({ lang: route.params.lang || 'en' }),
    meta: { layout: PlainLayout }
  },
  {
    path: '/:lang?/live-account-pre-registration/hm-app-ios/',
    name: 'register-ios',
    component: () => import('@/views/PreregAppView.vue'),
    props: (route) => ({ lang: route.params.lang || 'en' }),
    meta: { layout: PlainLayout }
  },
  {
    path: '/:lang?/hm-mt-demo-account/',
    name: 'demo-registration-app',
    component: () => import('@/views/DemoRegistractionAppView.vue'),
    props: (route) => ({ lang: route.params.lang || 'en' }),
    meta: { layout: PlainLayout }
  },
  {
    path: '/:lang?/legal/regulatory-environment/',
    name: 'regulatory-environment',
    component: () => import('@/views/RegulatoryEnvironmentView.vue'),
    props: (route) => ({
      lang: route.params.lang || 'en'
    })
  },
  {
    path: '/:lang?/update-preference/',
    name: 'unsubscribe',
    component: UnsubscribeView,
    props: (route) => ({ lang: route.params.lang || 'en' }),
    meta: { breadcrumbLabel: 'Update Preference' }
  },
  {
    path: '/:lang?/preferences-of-communication/',
    name: 'preferences-of-communication',
    component: UnsubscribePreferencesView,
    props: (route) => ({ lang: route.params.lang || 'en' }),
    meta: { breadcrumbLabel: 'Preferences' }
  },
  {
    path: '/:lang?/terms-and-conditions/:slug',
    name: 'terms-and-conditions',
    component: TermsAndConditionsView,
    props: (route) => ({ lang: route.params.lang || 'en' }),
    meta: { breadcrumbLabel: 'Terms and Conditions' }
  },
  {
    path: '/:lang?/company/sponsorships/:slug?',
    name: 'sponsorships',
    component: SponsorshipTemplateOne,
    props: (route) => ({ lang: route.params.lang || 'en' }),
    meta: { breadcrumbLabel: 'Sponsorships' }
  },
  {
    path: '/:lang?/company/sponsorships/',
    name: 'sponsorshipsOverview',
    component: SponsorshipOverview,
    props: (route) => ({ lang: route.params.lang || 'en' }),
    meta: { breadcrumbLabel: 'Sponsorships Overview' }
  },
  platformRoutes,
  partnerRoutes,
  toolsRoutes,
  tradingRoutes,
  companyRoutes,
  termsRoutes,
  {
    path: '/:lang?/blog/:slug',
    name: 'blog',
    component: () => import('@/views/BlogView.vue'),
    props: (route) => ({ lang: route.params.lang || 'en' })
  },
  {
    path: '/:lang?',
    name: 'home',
    component: HomeView,
    props: (route) => ({ lang: route.params.lang || 'en' }),
    meta: { breadcrumbLabel: 'Home' }
  },
  {
    path: '/:lang?/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue')
  }
]

export default routes
